import { gql } from 'graphql-request';

export const getBookingDifferences = async (): Promise<string> => {
  const response = await fetch('/schemas/bookingDifferences.txt');
  const text = await response.text();

  const query = gql`
    ${text}
  `;

  return query;
};
